<template>
  <div class="cropper-content" style="position: relative;margin-top: 30px">

    <div class="cropper-box-left">
      <h5 style="text-align: left;font-weight: bold;font-size: 16px">“中国教师资格网”免冠证件照要求：</h5>
      <p style=" font-size:14px;text-align: left;line-height: 30px">
        1.应上传本人近期<font color="red">一寸白底正面免冠</font>证件照。<br>
        2.照片中人像位置要居中，人物面部清晰，不可佩戴帽子、头饰、墨镜等。<br>
      </p>

      <h5 style="text-align: left;font-weight: bold;font-size: 16px">照片处理说明：</h5>
      <p style=" font-size:14px;text-align: left;line-height: 30px">
        1.裁剪的照片请参照“示例图”。<br>
        2.点击【确定裁剪并下载】按钮后，文件将下载至浏览器默认存储位置。<br>
      </p>
<!--      style="position: absolute;left: 315px;top:210px"-->

      <div class="cropper-box-left-img-list">
        <div  class="preview">
          <p style="width: 100%;text-align: left">
            <span style="width: 50px;"><font style="font-weight: bold">示例图：</font></span>
          </p>
          <img src="../assets/Example-icon2.jpg" alt="示例图" style="width: 149.5px;height: 209px">
        </div>

      <!--预览效果图-->
      <div class="show-preview">
        <p style="width: 100%;text-align: left">
          <span style="width: 50px;"><font style="font-weight: bold">预览：</font></span>
        </p>
        <div :style="previews.div ?previewsStyle : previews.div " class="preview" >
          <img :src="previews.url" :style="previews.img">
        </div>
      </div>

      </div>

    </div>
    <div class="cropper-box">
      <div>
        <div class="footer-btn">
          <div class="scope-btn">
                      <label class="btn" for="uploads">选择照片</label>
                      <input type="file" id="uploads" style="position:absolute; clip:rect(0 0 0 0);" accept="image/png, image/jpeg, image/gif, image/jpg" @change="selectImg($event)">
          </div>
          <div class="upload-btn">
            <!--          <a-button type="primary" @click="uploadImg('blob')" style="margin-right: 5px"><Icon type="ios-cloud-upload" />上传封面</a-button>-->
            <a-button
              @click="down('blob')"
              type="danger"
              icon="download"
            >确定裁剪并下载</a-button>
          </div>
        </div>

        <div class="cropper" :style="{width:setWidth  +'px',height:setHeight  + 'px'}">
          <VueCropper
            ref="cropper"
            :img="option.img"
            :outputSize="option.outputSize"
            :outputType="option.outputType"
            :info="option.info"
            :canScale="option.canScale"
            :autoCrop="option.autoCrop"
            :autoCropWidth="option.autoCropWidth"
            :autoCropHeight="option.autoCropHeight"
            :fixed="option.fixed"
            :fixedNumber="option.fixedNumber"
            :full="option.full"
            :fillColor="option.fillColor"
            :fixedBox="option.fixedBox"
            :canMove="option.canMove"
            :canMoveBox="option.canMoveBox"
            :original="option.original"
            :centerBox="option.centerBox"
            :height="option.height"
            :infoTrue="option.infoTrue"
            :maxImgSize="option.maxImgSize"
            :enlarge="option.enlarge"
            :mode="option.mode"
            @realTime="realTime"
            @imgLoad="imgLoad">
          </VueCropper>
        </div>
      </div>

      <!--底部操作工具按钮-->
      <div class="footer-btn">

        <div class="scope-btn" style="margin-left: 15px">
<!--          <label class="btn" for="uploads">选择照片</label>-->
<!--          <input type="file" id="uploads" style="position:absolute; clip:rect(0 0 0 0);" accept="image/png, image/jpeg, image/gif, image/jpg" @change="selectImg($event)">-->
          <a-button class="btn"  type="primary" plain  @click="changeScale(1)" icon="zoom-in" style="margin-top: 30px">放大</a-button>
          <a-button class="btn" type="primary" plain  @click="changeScale(-1)" icon="zoom-out">缩小</a-button>
          <a-button class="btn" type="primary" plain @click="rotateLeft" icon="undo">左旋转</a-button>
          <a-button class="btn" type="primary" plain @click="rotateRight" icon="redo">右旋转</a-button>
        </div>
<!--        <div class="upload-btn">-->
<!--&lt;!&ndash;          <a-button type="primary" @click="uploadImg('blob')" style="margin-right: 5px"><Icon type="ios-cloud-upload" />上传封面</a-button>&ndash;&gt;-->
<!--          <a-button-->
<!--            @click="down('blob')"-->
<!--            type="primary"-->
<!--            icon="download"-->
<!--          >下载</a-button>-->
<!--        </div>-->
      </div>
    </div>


  </div>
</template>

<script>
import VueCropper from '../vueCropper/vue-cropper.vue'

const setWidth = 295;
const setHeight = 413;
export default {
  name: "Name",
  components: {
    VueCropper
  },
  props:[
    'imageFile'
  ],
  data() {
    return {
      flag:false,
      setWidth:setWidth,
      setHeight:setHeight,
      name:this.Name,
      previews: {},
      previewsStyle:"  border: 1px solid #cccccc;width: 147.5px;height: 206.5px",


      option:{
        // img: '', // 裁剪图片的地址
        // info: false, // 裁剪框的大小信息
        // outputSize: 1, // 剪切后的图片质量（0.1-1）
        // outputType: 'jpg', // 裁剪生成的图片的格式
        // canMove: true,  // 上传图片是否可以移动
        // original: false,  // 上传图片是否显示原始宽高
        // canMoveBox: true,  // 截图框能否拖动
        // autoCrop: true, // 是否默认生成截图框
        // autoCropWidth: 296/3,
        // autoCropHeight: 414/3,
        // fixedBox: true, // 截图框固定大小
        // fixed:false, //是否开启截图框宽高固定比例
        // enlarge:3,//图片根据截图框输出比例倍数



        img: '',             //裁剪图片的地址
        backgroundColor: '#ffffff',
        info: false,
        fillColor:'#ffffff',
        outputSize: 1,       //裁剪生成图片的质量(可选0.1 - 1)
        outputType: 'jpeg',  //裁剪生成图片的格式（jpeg || png || webp）
        //info: true,          //图片大小信息
        canScale: true,      //图片是否允许滚轮缩放
        autoCrop: true,      //是否默认生成截图框
        // autoCropWidth: 230,  //默认生成截图框宽度
        // autoCropHeight: 150, //默认生成截图框高度
        autoCropWidth: setWidth/2,  //默认生成截图框宽度
        autoCropHeight: setHeight/2, //默认生成截图框高度
        //fixed: true,         //是否开启截图框宽高固定比例
       // fixedNumber: [1, 1], //截图框的宽高比例
        full: false,         //false按原比例裁切图片，不失真
        fixedBox: true,      //固定截图框大小，不允许改变
        canMove: false,      //上传图片是否可以移动
        canMoveBox: true,    //截图框能否拖动
        original: false,     //上传图片按照原始比例渲染
        centerBox: false,    //截图框是否被限制在图片里面
        //high: true,        //是否按照设备的dpr 输出等比例图片
        //infoTrue: false,     //true为展示真实输出图片宽高，false展示看到的截图框宽高
        //maxImgSize: 3000,    //限制图片最大宽度和高度
        enlarge: 2,          //图片根据截图框输出比例倍数
        //mode: '230px 150px'  //图片默认渲染方式
       // mode: '295px 413px'  //图片默认渲染方式

      }
    };
  },
   mounted() {

    // await this.isBackColor()

  },
  methods: {
    //初始化函数
    imgLoad (msg) {
      console.log("工具初始化函数====="+msg)
    },
    //图片缩放
    changeScale (num) {
      num = num || 1
      this.$refs.cropper.changeScale(num)
    },
    //向左旋转
    rotateLeft () {
      this.$refs.cropper.rotateLeft()
    },
    //向右旋转
    rotateRight () {
      this.$refs.cropper.rotateRight()
    },
    //实时预览函数
    realTime (data) {
      console.log(data);
      this.previews = data
      //预览图永远和图片原始尺寸相等
      // this.previews.img.maxWait = data.img.width
    },

    //选择图片
    selectImg (e) {
      let file = e.target.files[0]
      if (!/.(jpg|jpeg|png|JPG|PNG)$/.test(e.target.value)) {
        this.$message({
          message: '图片类型要求：jpeg、jpg、png',
          type: "error"
        });
        return false
      }
      //转化为blob
      let reader = new FileReader()
      reader.onload = (e) => {
        let data
        if (typeof e.target.result === 'object') {
          data = window.URL.createObjectURL(new Blob([e.target.result]))
        } else {
          data = e.target.result
        }
        this.option.img = data
      }
      //转化为base64
      reader.readAsDataURL(file)
    },
     isBackColor(src = ''){
       return new Promise((resolve, reject)=> {
         var img = new Image();
         // const path = require('./static/author-img11111.jpg');
         img.src = src;
         const that =this;
         img.onload = function() {
           let canvas = document.createElement('canvas');
           let ctx = canvas.getContext('2d');
           ctx.drawImage(img, 0, 0);
           console.log(img.width, img.height);
           // let imageData = ctx.getImageData(0, 0, img.width, img.height).data;

           let width = 177,
             height = 247;
           let leftWidth = Math.floor(width/8),
             leftHeight =  Math.floor((height/3) * 2);
           let topWidth = width,
             topHeight = Math.floor((height/5));
           let rightX = Math.floor((width/8) * 7),
             rightWidth = Math.floor((width/8)),
             rightHeight =  Math.floor((height/3) * 2);


           //左上角
         let imageData = ctx.getImageData(0, 0, 1, 1).data,
             imageData2 = ctx.getImageData(0,   Math.floor((247/2)), 1, 1).data,
             imageData3 = ctx.getImageData(Math.floor((280/2)), 30, 1, 1).data,
             imageData4 = ctx.getImageData(280, 0, 1, 1).data,
             imageData5 = ctx.getImageData(280,  Math.floor((247/2)), 1, 1).data;

          // let imageData2 = ctx.getImageData(0,  0, 5, 413).data;
          //  console.log(imageData2);

           let data = that.getColors(imageData,'left');
           let data2 = that.getColors(imageData2,'top');
           let data3 = that.getColors(imageData3,'left');
           let data4 = that.getColors(imageData4,'top');
           let data5 = that.getColors(imageData5,'top');
          //  console.log(data2);

           let arr = [...data.arr,...data2.arr,...data3.arr,...data4.arr,...data5.arr];
           console.log(arr);
           this.flag = arr.some((v,i) => {
             return v < 210;
           })
           resolve(this.flag); // 图片加载完成，将img对象传递给resolve
         };
         img.onerror = function() {
           reject(new Error('Image load failed')); // 图片加载失败，reject带上错误信息
         };
         // img.src = url; // 设置图片的src，开始加载图片
       });

    },
    getColors(imageData = [],text){
      // 分析像素数据
      let bgColors = {};
      for (let i = 0; i < imageData.length; i += 4) {
        let r = imageData[i];
        let g = imageData[i + 1];
        let b = imageData[i + 2];
        let rgb = `rgb(${r},${g},${b})`;
        if (!bgColors[rgb]) {
          bgColors[rgb] = 1;
          bgColors.arr = [r,g,b];
        } else {
          bgColors[rgb]++;
          bgColors.arr = [r,g,b];
        }
      }
      return  bgColors;

      // 找到出现次数最多的背景色
      // let maxCount = 0;
      // let bgColor = '';
      // for (let color in bgColors) {
      //   if (bgColors[color] > maxCount) {
      //     maxCount = bgColors[color];
      //     bgColor = color;
      //   }
      // }
      console.log('背景色：', bgColor,text);
    },
    async down(type) {
      // event.preventDefault()
      var aLink = document.createElement("a");
      aLink.download = "author-img";
      // 输出
      if (type === "blob") {
        this.$refs.cropper.getCropBlob(async (data) => {
          console.log(data, type);
          // let formData = new FormData();
          // formData.append('imageFile',data,"DX.jpg")
          this.downImg = window.URL.createObjectURL(data);
          // aLink.download = this.downImg;
          // await this.isBackColor(this.downImg)
          console.log(this.downImg);
          const flag = await this.isBackColor(this.downImg)

          // const flag = await this.isBackColor(imgsrc);
          if(flag){
            alert("图片不合格或背景颜色不是白色。");
            // this.$message.error("图片不合格或背景颜色不是白色。");
            // this.$message({
            //   message:"图片不合格或背景颜色不是白色。",
            //   type:"error",
            //   customClass:"messageIndex"
            // })
            return false;
          }
          aLink.href = window.URL.createObjectURL(data);
          aLink.click();
        });
      } else {
          this.$refs.cropper.getCropData(async (data) => {
            console.log(data);
            this.downImg = data;
            const flag = await this.isBackColor(this.downImg)
            if(flag){
              alert("图片不合格或背景颜色不是白色。");
              // this.$message.error("图片不合格或背景颜色不是白色。");
              // this.$message({
              //   message:"图片不合格或背景颜色不是白色。",
              //   type:"error",
              //   customClass:"messageIndex"
              // })
              return false;
            }
            // if(this.isBackColor(this.downImg)){
            //   this.$message.error("图片不合格或背景颜色不是白色。");
            //   return false;
            // }
            aLink.href = data;
            aLink.click();
          });
      }

    },
    //上传图片
    uploadImg (type) {
      let _this = this;
      if (type === 'blob') {
        console.log(this.$refs)
        //获取截图的blob数据
        this.$refs.cropper.getCropBlob(async (data) => {
          let formData = new FormData();
          formData.append('imageFile',data,"DX.jpg")
          //调用axios上传
          let {data: res} = await _this.$http.post(this.road+'upload_image?appid='+this.paramce.appid+'&appsecret='+this.paramce.appsecret+'&token='+this.paramce.token, formData)
          if(res.code === '200'){
            _this.$Message.info({
              content:res.errorMessage,
              duration: 2,
            });
            let imgInfo = {
              name : _this.Name,
              url : res.result
            };
            _this.$emit('uploadImgSuccess',imgInfo); //子组件设置父组件的方法
          }else {
            _this.$Message.info({
              content:res.errorMessage,
              duration: 2,
            });
          }
        })
      }
    },

  },
}
</script>

<style scoped lang="less">
.messageIndex{
  z-index: 9999 !important;
}

.cropper-box-left{
      width: 500px;
      margin-right:20px;
  .cropper-box-left-img-list{
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    margin-top: 20px;
  }
}
.file_load{
  padding: 0px 10px;
  border-radius: 3px;
  background:rgb(51,153,255);
  color:#fff;
  border:none
}
.file_load i{
  color:#f4f4f4
}
.cropper-content{
  display: flex;
  display: -webkit-flex;
  //justify-content: flex-end;
  .cropper-box{
    // flex: 1;
    //width: 100%;
    display:flex;
    .cropper{
      width: auto;
      height: 300px;
      background: #ffffff;
    }
  }

  .show-preview{
    //flex: 1;
    //-webkit-flex: 1;
    //display: flex;
    //display: -webkit-flex;
    //justify-content: center;
    .preview{
      //width: 213px;
      //height: 495px;
      overflow: hidden;
      border:1px solid #67c23a;
      //background: #cccccc;
      background: #ffffff;
    }
  }
}
.footer-btn{
  //margin-top: 30px;
  margin-bottom: 15px;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  //justify-content: flex-end;
  .scope-btn{
    display: flex;
    display: -webkit-flex;
    //justify-content: space-around;
    flex-direction: column;
    padding-right: 10px;
    justify-content: space-around;
    //margin-left: 15px;
    //.btn{
    //  margin-bottom: 65px;
    //}
  }
  .upload-btn{
    //flex: 1;
    //-webkit-flex: 1;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
  }
  .btn {
    outline: none;
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    -webkit-appearance: none;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: 0;
    -webkit-transition: .1s;
    transition: .1s;
    font-weight: 500;
    height: 32px;
    line-height: 32px;
    padding: 0 15px;
    //padding: 8px 15px;
    font-size: 12px;
    border-radius: 3px;
    color: #fff;
    background-color: #409EFF;
    border-color: #409EFF;
    margin-right: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CropperComponent.vue